export default "__VITE_ASSET__BUwX7yrv__"